import { apiService } from '../services/apiService';
import { isExtension } from './extensionBridge';

// The one correct way to read the current user's bearer token from anywhere that isn't
// apiService.ts itself (which already tracks it in memory via setToken()/getToken() and
// attaches it automatically to every apiService.request() call). A direct
// `localStorage.getItem('token')` read - which aiService.ts and planService.ts both used
// to do, independently, all over these files - is only correct on desktop/web/Android,
// where this code runs in the SAME origin the token was written to (kalimatai.com's own
// localStorage, or Android's WebView rendering that same origin).
//
// The browser extension is the one platform where that's false: this code executes
// inside a content script injected into an arbitrary host page, whose `localStorage` has
// nothing to do with kalimatai.com's. The real token lives in `chrome.storage.local`
// (relayed by browser-extension/src/content/auth-sync.ts) and is seeded into
// apiService's in-memory token via apiService.setToken() - see selection.tsx. Every
// direct `localStorage.getItem('token')` read outside of apiService.ts's own
// constructor/login/register (which run in the right origin by construction) needs to go
// through this helper instead, or it silently reads nothing in the extension and the
// request goes out unauthenticated (or, worse, some call sites didn't even guard against
// a null token and sent a literal `Authorization: Bearer null` header - see
// planService.ts's pre-fix history). CorrectionPopup.tsx has its own equivalent
// getStoredToken() inline for the same reason.
export function getStoredAuthToken(): string | null {
  if (isExtension) return apiService.getToken();
  return typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
}
